var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "700",
            "max-height": "700",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.openVideo,
            callback: function($$v) {
              _vm.openVideo = $$v
            },
            expression: "openVideo"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "vCardDialogVideo", shaped: "", outlined: "" } },
            [
              _c("div", { attrs: { id: "headerDialogVideo" } }, [
                _c("div", { staticStyle: { "margin-left": "2%" } }, [
                  _c("h2", { staticClass: "textstyle" }, [
                    _vm._v(_vm._s(_vm.titleDialog))
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticStyle: { "margin-left": "auto", "margin-right": "0" }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", dark: "" },
                        on: {
                          click: function($event) {
                            _vm.openVideo = false
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("close")])],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { attrs: { id: "bodyDialogVideo" } },
                [
                  _c(
                    "video",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isDownload,
                          expression: "!isDownload"
                        }
                      ],
                      attrs: {
                        src: _vm.videoUrl,
                        controls: "",
                        id: "videoDialog"
                      }
                    },
                    [
                      _c("source", {
                        attrs: { src: _vm.videoUrl, type: "video/mp4" }
                      })
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isDownload,
                          expression: "isDownload"
                        }
                      ],
                      attrs: {
                        href: _vm.videoUrl,
                        id: "btnDownloadDialog",
                        color: "#27488E",
                        dark: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.openVideo = false
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("upload")]),
                      _vm._v("Descargar video")
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card", staticStyle: { width: "1030px" } },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { "overflow-y": "visible !important" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticClass: "v-title",
                              attrs: { align: "left" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "margin-bottom": "6px"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "divTextDetail" }, [
                                    _vm._v("Patente:")
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "divTextDetailValue" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.selectedVOD.patente) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "margin-bottom": "6px"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "divTextDetail" }, [
                                    _vm._v("Rango:")
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "divTextDetailValue" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.selectedVOD.rango_solicitado
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "margin-bottom": "6px"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "divTextDetail" }, [
                                    _vm._v("Canal:")
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "divTextDetailValue" },
                                    [_vm._v(_vm._s(_vm.selectedVOD.chl))]
                                  )
                                ]
                              ),
                              _c("v-divider")
                            ],
                            1
                          ),
                          _c("v-layout", { attrs: { wrap: "" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "100%",
                                  display: "flex",
                                  "justify-content": "center"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gridcard rounded-card",
                                    staticStyle: { display: "inline-block" }
                                  },
                                  [
                                    _c("GridComponent", {
                                      ref: "gridComponent",
                                      staticClass: "ag-theme-material",
                                      attrs: {
                                        id: "gridComponent",
                                        gridOptions: _vm.gridOptions
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }